<img
    src="assets/images/sa-connect-logo.png"
    alt="Connect"
    class="sa-logo"
    href="https://www.standards.org.au/"
    target="_blank"
    title="Home, Standards Australia"
/>
